module.exports = __webpack_public_path__ + "img/n1.0b94714f.jpg";